import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useEffect, useRef } from "react"
import DocumentDraftBootstrapPage from "../../../../../components/WMS/shared/DocumentDraftBootstrapPage"
import { useCreatePW } from "../../../../../components/WMS/Transfers/PW/useCreatePW"

export const Route = createFileRoute("/_layout/WMS/documents/doc-pw/new")({
  component: CreatePwPage,
})

function CreatePwPage() {
  const navigate = useNavigate()
  const { createPW, isCreating, isResolvingWarehouses, canCreate } =
    useCreatePW()
  const initializedRef = useRef(false)

  useEffect(() => {
    if (initializedRef.current) return
    if (isResolvingWarehouses) return
    if (!canCreate) return
    initializedRef.current = true
    createPW()
  }, [canCreate, createPW, isResolvingWarehouses])

  const handleCancel = () =>
    navigate({
      to: "/WMS/documents/document-list",
      search: { page: 1, page_size: 50 },
    })

  return (
    <DocumentDraftBootstrapPage
      title="Utwórz dokument PW"
      onCancel={handleCancel}
      isBusy={isCreating || isResolvingWarehouses}
      canCreate={canCreate}
      busyLabel="Tworzenie szkicu PW..."
      idleLabel="Przygotowywanie edycji dokumentu PW..."
    />
  )
}
